export default {
    primaryColor: '#FF9933',
    APP_NAME: 'dMonk',
    APP_VERSION: '0.2.49',
    APP_MODE: process.env.NODE_ENV || 'development',
    SERVER_BASE_URL: process.env.REACT_APP_BASE_URL,
    DROPBOX_CALLBACK_URL: process.env.REACT_APP_DROPBOX_CALLBACK_URL,
    DROPBOX_APP_KEY: process.env.REACT_APP_DROPBOX_APP_KEY,
    FILE_SERVICES: {
        DROPBOX: 'dropbox',
        ONEDRIVE: 'onedrive',
        GOOGLEDRIVE: 'googledrive',
        NEXTCLOUD: 'nextcloud',
    },
    STORAGE_SERVICES: {
        DROPBOX: 'dropbox',
        ONEDRIVE: 'onedrive',
        GOOGLEDRIVE: 'googledrive',
        NEXTCLOUD: 'nextcloud'
    },
    SERVICES: {
        MIRO: 'miro',
        ONEDRIVE: 'onedrive',
    },
    SERVICE_NAME_MAP: {
        dropbox: 'Dropbox',
        onedrive: 'Onedrive',
        googledrive: 'Google Drive',
        miro: 'Miro',
    },
    SERVICE_CATEGORY_MAP: {
        dropbox: 'Storage',
        onedrive: 'Storage',
        googledrive: 'Storage',
        miro: 'Workspace',
    },
    USER_ROLES: {
        SUPERADMIN: 'superadmin',
        ADMIN: 'admin',
        MANAGER: 'manager',
        USER: 'user'
    },
    USER_ACCOUNT_TYPES: {
        PERSONAL: 'personal',
        BUSINESS: 'business'
    },
    DATETIMEOPTIONS : {
        DATE_TIME_FORMAT : "MMM Do YYYY, h:mm a"
    },
    timeZones: [
        { label: "-12:00", value: "-12:00" },
        { label: "-11:00", value: "-11:00" },
        { label: "-10:00", value: "-10:00" },
        { label: "-09:30", value: "-09:30" },
        { label: "-09:00", value: "-09:00" },
        { label: "-08:00", value: "-08:00" },
        { label: "-07:00", value: "-07:00" },
        { label: "-06:00", value: "-06:00" },
        { label: "-05:00", value: "-05:00" },
        { label: "-04:00", value: "-04:00" },
        { label: "-03:30", value: "-03:30" },
        { label: "-03:00", value: "-03:00" },
        { label: "-02:00", value: "-02:00" },
        { label: "-01:00", value: "-01:00" },
        { label: "00:00", value: "00:00" },
        { label: "+01:00", value: "+01:00" },
        { label: "+02:00", value: "+02:00" },
        { label: "+03:00", value: "+03:00" },
        { label: "+03:30", value: "+03:30" },
        { label: "+04:00", value: "+04:00" },
        { label: "+04:30", value: "+04:30" },
        { label: "+05:00", value: "+05:00" },
        { label: "+05:30", value: "+05:30" },
        { label: "+05:45", value: "+05:45" },
        { label: "+06:00", value: "+06:00" },
        { label: "+06:30", value: "+06:30" },
        { label: "+07:00", value: "+07:00" },
        { label: "+08:00", value: "+08:00" },
        { label: "+08:45", value: "+08:45" },
        { label: "+09:00", value: "+09:00" },
        { label: "+09:30", value: "+09:30" },
        { label: "+10:00", value: "+10:00" },
        { label: "+10:30", value: "+10:30" },
        { label: "+11:00", value: "+11:00" },
        { label: "+12:00", value: "+12:00" },
        { label: "+12:45", value: "+12:45" },
        { label: "+13:00", value: "+13:00" },
        { label: "+14:00", value: "+14:00" },
      ],
    timeFormats: [
        { label: "hh:mm A", value: "hh:mm A" },
        { label: "HH:mm", value: "HH:mm" },
        ],
    dateFormats: [
        { label: "DD/MM/YYYY", value: "DD/MM/YYYY" },
        { label: "MM/DD/YYYY", value: "MM/DD/YYYY" },
        { label: "YYYY/MM/DD", value: "YYYY/MM/DD" },
        { label: "DD-MM-YYYY", value: "DD-MM-YYYY" },
        { label: "MM-DD-YYYY", value: "MM-DD-YYYY" },
        { label: "YYYY-MM-DD", value: "YYYY-MM-DD" },
        { label: "MMM Do YYYY", value: "MMM Do YYYY" }
        ],
    workingDays: [
        { label: "Monday", value: "Monday" },
        { label: "Tuesday", value: "Tuesday" },
        { label: "Wednesday", value: "Wednesday" },
        { label: "Thursday", value: "Thursday" },
        { label: "Friday", value: "Friday" },
        { label: "Saturday", value: "Saturday" },
        { label: "Sunday", value: "Sunday" },
        ],
    nonWorkingDays: [
        { label: "Monday", value: "Monday" },
        { label: "Tuesday", value: "Tuesday" },
        { label: "Wednesday", value: "Wednesday" },
        { label: "Thursday", value: "Thursday" },
        { label: "Friday", value: "Friday" },
        { label: "Saturday", value: "Saturday" },
        { label: "Sunday", value: "Sunday" },
        ],
}
